var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UsageDataHostDetail',{attrs:{"data-host-id":_vm.dataHostId}})
}
var staticRenderFns = []

export { render, staticRenderFns }